import user from './user';
const state = {
	StoreSessionList: [],
	StoreHistoryList: [],
	StoreSessionCurrentNode: '',
	StoreMessageCount: 0,
	StoreImageView: '',
	StoreIsImageView: false
};

const mutations = {
	SET_SESSION_LIST_ADD: (state, Item) => {
		state.StoreSessionList.unshift(Item);
		Item.index = 0;
		state.StoreSessionCurrentNode = Item;
		localStorage.setItem(`know-service-session-list-${user.state.userInfo.account}`, JSON.stringify(state.StoreSessionList));
	},
	SET_SESSION_LIST_DELETE: (state, Index) => {
		state.StoreSessionList.splice(Index, 1);
		localStorage.setItem(`know-service-session-list-${user.state.userInfo.account}`, JSON.stringify(state.StoreSessionList));
	},
	SET_SESSION_LIST_EDIT: (state, data) => {
		state.StoreSessionList[data.index] = data.row;
		localStorage.setItem(`know-service-session-list-${user.state.userInfo.account}`, JSON.stringify(state.StoreSessionList));
	},
	SET_HISTORY_LIST: (state, Item) => {
		if(state.StoreHistoryList.length === 10) {
			state.StoreHistoryList.splice(9 , 1);
		}
		state.StoreHistoryList.unshift(Item);
		// localStorage.setItem(`know-service-history-list-${user.state.userInfo.account}`, JSON.stringify(state.StoreHistoryList));
	},
	SET_SESSION_CURRENT_NODE: (state, Item) => {
		state.StoreSessionCurrentNode = Item;
	},
	SET_MESSAGE_COUNT: (state, type) => {
		if(type === 'desc') {
			state.StoreMessageCount = state.StoreMessageCount - 1;
		} else if(type === 'asc') {
			state.StoreMessageCount = state.StoreMessageCount + 1;
		} else {
			Vue.prototype.$api.apiPostKnowledgeMessageCount({
				acceptUserId: user.state.userInfo.userId,
				read: 0
			}).then(response => {
				if(response.errcode != 0) return;
				state.StoreMessageCount = response.data;
			});
		}
	},
	SET_IMAGE_VIEW: (state, data) => {
		state.StoreImageView = data.url;
		state.StoreIsImageView = data.isShow;
	}
};

const actions = {
	StoreKnowledgeAction({state}) {
		const year = new Date().getFullYear();
		const month = new Date().getMonth();
		const date = new Date().getDate();
		const time = new Date(year, month, date, 23, 59, 0).getTime() / 1000;
		const expired = localStorage.getItem(`know-service-expired-${user.state.userInfo.account}`);
		if(expired) {
			if(parseFloat(expired) < new Date().getTime() / 1000) {
				localStorage.removeItem(`know-service-session-list-${user.state.userInfo.account}`);
				// localStorage.removeItem(`know-service-history-list-${user.state.userInfo.account}`);
				localStorage.removeItem(`know-service-expired-${user.state.userInfo.account}`);
			} else {
				state.StoreSessionList = JSON.parse(localStorage.getItem(`know-service-session-list-${user.state.userInfo.account}`)) || [];
				// state.StoreHistoryList = JSON.parse(localStorage.getItem(`know-service-history-list-${user.state.userInfo.account}`)) || [];
			}
		} else {
			localStorage.setItem(`know-service-expired-${user.state.userInfo.account}`, time);
		}
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}